import { useEffect, useState } from 'react'

/**
 * useUserAvatar returns the best available avatar URL for the current user.
 *
 * Priority:
 *  1. Telegram initData `photo_url` (instant, when the client provides it)
 *  2. The server-provided avatar cached at login (`auth_avatar_url`), which the
 *     backend re-hosts from the Bot API when initData has no photo.
 *
 * It updates reactively when authentication finishes (the `auth:avatar` event),
 * so the photo appears without a reload even on first login.
 */
export function useUserAvatar(): string | undefined {
  const tgPhoto = (window as any).Telegram?.WebApp?.initDataUnsafe?.user?.photo_url as string | undefined

  const [avatar, setAvatar] = useState<string | undefined>(
    () => tgPhoto || localStorage.getItem('auth_avatar_url') || undefined
  )

  useEffect(() => {
    const handler = (e: Event) => {
      if (tgPhoto) return // Telegram photo always wins
      const detail = (e as CustomEvent).detail as string | null
      setAvatar(detail || undefined)
    }
    window.addEventListener('auth:avatar', handler)
    return () => window.removeEventListener('auth:avatar', handler)
  }, [tgPhoto])

  return avatar
}
